import { render, staticRenderFns } from "./mzj_slideshow.vue?vue&type=template&id=48bd9382&scoped=true&"
import script from "./mzj_slideshow.vue?vue&type=script&lang=js&"
export * from "./mzj_slideshow.vue?vue&type=script&lang=js&"
import style0 from "./mzj_slideshow.vue?vue&type=style&index=0&id=48bd9382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd9382",
  null
  
)

export default component.exports